"use client";
import type { BillingPeriod } from "./use-paywall-state";

/**
 * Hook to get product titles, descriptions, value props, and billing defaults
 * Uses fixed values as the two-product paywall variant won the experiment
 * Note: NovPaywall2Products experiment connection removed - using finalized values
 */
export default function usePaywallProductTitles() {
  // Fixed product titles and descriptions
  const RxProductTitle = "Fast Prescriptions";
  const PedsProductTitle = "Comprehensive Kids Care";
  const RxProductDescription = "The easiest way to get treatment";
  const PedsProductDescription = "Support & guidance from pediatricians";

  // RX value props (order: top to bottom)
  const RxValue1 = "Board-certified doctors review symptoms";
  const RxValue2 = "Prescriptions available for 30+ conditions";
  const RxValue3 = "No back-and-forth; just submit a request";
  const RxValue4 = "One subscription covers the whole family (*ages 2 and up)";
  const RxValue5 = "Medications sent right to your pharmacy";
  const RxValue6 = "No fees or waiting rooms – ever";
  const RxValue7 = "hidden"; // Not used

  // Peds value props (order: top to bottom)
  const PedsValue1 = "Board-certified pediatricians 24/7";
  const PedsValue2 = "Unlimited messaging and phone calls";
  const PedsValue3 = "Responses in under an hour";
  const PedsValue4 = "Diagnoses, treatment, & follow-ups";
  const PedsValue5 = "Covers all children in your household (age 0-18 yrs)";
  const PedsValue6 = "Available 365 days a year";
  const PedsValue7 = "hidden"; // Not used

  // Default billing period is yearly (per requirements)
  const defaultBilling: BillingPeriod = "yearly";

  return {
    RxProductTitle,
    PedsProductTitle,
    RxProductDescription,
    PedsProductDescription,
    RxValue1,
    RxValue2,
    RxValue3,
    RxValue4,
    RxValue5,
    RxValue6,
    RxValue7,
    PedsValue1,
    PedsValue2,
    PedsValue3,
    PedsValue4,
    PedsValue5,
    PedsValue6,
    PedsValue7,
    defaultBilling,
  };
}
